/** Strict per-product limits: fresh cart, shared mutation queue, no partial additions. */
(function () {
  'use strict';

  var config = window.HS_CART_QTY_LIMITS;
  if (!config || !config.enabled || !config.limits) return;

  var limitKeys = Object.keys(config.limits);
  if (!limitKeys.length) return;

  var originalFetch = window.fetch.bind(window);
  var cartCache = { items: [], loaded: false, loading: null };

  function notify(message) {
    if (!message) return;
    try {
      if (typeof window.showWarning === 'function' && document.getElementById('halo-warning-popup')) {
        window.showWarning(message);
        return;
      }
    } catch (e) {}
    try {
      alert(message);
    } catch (e2) {}
  }

  function formatMessage(max) {
    var template =
      config.message ||
      'Limite de {{max}} unidades deste produto por pedido.';
    return String(template).replace(/\{\{\s*max\s*\}\}/gi, String(max));
  }

  function formatClampMessage(added, max) {
    return (
      formatMessage(max) +
      ' Adicionamos ' +
      added +
      (added === 1 ? ' unidade' : ' unidades') +
      '.'
    );
  }

  function cartUrl(path) {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      (window.routes && window.routes.root) ||
      '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + path.replace(/^\//, '');
  }

  function isCartMutateUrl(url) {
    if (!url) return null;
    var str = String(url);
    if (/\/cart\/add(?:\.js)?(?:\?|$)/i.test(str)) return 'add';
    if (/\/cart\/change(?:\.js)?(?:\?|$)/i.test(str)) return 'change';
    if (/\/cart\/update(?:\.js)?(?:\?|$)/i.test(str)) return 'update';
    return null;
  }

  function refreshCartCache() {
    cartCache.loading = originalFetch(cartUrl('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('CART_READ_FAILED');
        return res.json();
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) throw new Error('CART_READ_FAILED');
        cartCache.items = cart.items;
        cartCache.loaded = true;
        cartCache.loading = null;
        return cartCache.items;
      })
      .catch(function () {
        cartCache.loading = null;
        throw new Error('CART_READ_FAILED');
      });
    return cartCache.loading;
  }

  function ensureCart() {
    if (cartCache.loaded) return Promise.resolve(cartCache.items);
    if (cartCache.loading) return cartCache.loading;
    return refreshCartCache();
  }

  function qtyInCartForProduct(productId, items, excludeKey) {
    var total = 0;
    var pid = String(productId);
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (excludeKey && item.key === excludeKey) continue;
      if (String(item.product_id) === pid) {
        total += parseInt(item.quantity, 10) || 0;
      }
      var contents = config.components && config.components[String(item.product_id)];
      if (contents && Number(contents[pid]) > 0) {
        total += (parseInt(item.quantity, 10) || 0) * Number(contents[pid]);
      }
    }
    return total;
  }

  function resolveProductId(variantId, items) {
    if (variantId == null || variantId === '') return null;
    var vid = String(variantId);
    if (config.variantToProduct && config.variantToProduct[vid] != null) {
      return String(config.variantToProduct[vid]);
    }
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === vid || String(items[i].id) === vid) {
        return String(items[i].product_id);
      }
    }
    return null;
  }

  function findLine(items, idOrKey) {
    if (idOrKey == null || idOrKey === '') return null;
    var token = String(idOrKey);
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.key === token) return item;
      if (String(item.variant_id) === token) return item;
      if (String(item.id) === token) return item;
      if (String(item.product_id) === token) return item;
    }
    return null;
  }

  function getMax(productId) {
    if (productId == null) return null;
    var max = config.limits[productId];
    if (max == null) max = config.limits[String(productId)];
    if (max == null) return null;
    max = parseInt(max, 10);
    return isNaN(max) || max < 1 ? null : max;
  }

  function parseBody(body) {
    if (body == null || body === '') return {};
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var data = {};
      body.forEach(function (value, key) {
        data[key] = value;
      });
      return data;
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      var params = {};
      body.forEach(function (value, key) {
        params[key] = value;
      });
      return params;
    }
    if (typeof body === 'string') {
      var trimmed = body.trim();
      if (!trimmed) return {};
      if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
        try {
          return JSON.parse(trimmed);
        } catch (e) {
          return {};
        }
      }
      var out = {};
      trimmed.split('&').forEach(function (pair) {
        var parts = pair.split('=');
        if (parts.length >= 2) {
          out[decodeURIComponent(parts[0])] = decodeURIComponent(
            parts.slice(1).join('=').replace(/\+/g, ' ')
          );
        }
      });
      return out;
    }
    if (typeof body === 'object') return body;
    return {};
  }

  function clonePayload(payload) {
    try {
      return JSON.parse(JSON.stringify(payload));
    } catch (e) {
      return payload;
    }
  }

  function rebuildBody(originalBody, payload) {
    if (typeof FormData !== 'undefined' && originalBody instanceof FormData) {
      var fd = new FormData();
      originalBody.forEach(function (value, key) {
        if (key === 'quantity' || key === 'id') return;
        fd.append(key, value);
      });
      if (payload.id != null) fd.append('id', payload.id);
      if (payload.quantity != null) fd.append('quantity', payload.quantity);
      else if (originalBody.get('quantity') != null) fd.append('quantity', originalBody.get('quantity'));
      return fd;
    }

    if (typeof originalBody === 'string') {
      var trimmed = originalBody.trim();
      if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
        return JSON.stringify(payload);
      }
      var params = new URLSearchParams();
      Object.keys(payload).forEach(function (key) {
        if (key === 'items' || key === 'updates') return;
        if (payload[key] != null) params.set(key, payload[key]);
      });
      return params.toString();
    }

    if (typeof URLSearchParams !== 'undefined' && originalBody instanceof URLSearchParams) {
      var usp = new URLSearchParams();
      Object.keys(payload).forEach(function (key) {
        if (key === 'items' || key === 'updates') return;
        if (payload[key] != null) usp.set(key, payload[key]);
      });
      return usp;
    }

    return JSON.stringify(payload);
  }

  function rebuildJQueryData(originalData, payload) {
    if (typeof originalData === 'string') {
      return rebuildBody(originalData, payload);
    }
    if (originalData && typeof originalData === 'object') {
      return payload;
    }
    return payload;
  }

  /**
   * @returns {{ blocked?: boolean, clamped?: boolean, message?: string, payload?: object }}
   */
  function enforceLimits(action, payload, items) {
    var next = clonePayload(payload);
    var simulated = items.map(function(item){return Object.assign({},item);});
    function invalid(){return {blocked:true,message:'Não conseguimos conferir a quantidade. Tente novamente.'};}
    function quantity(value, fallback){var q=value===undefined?fallback:Number(value);return Number.isInteger(q)&&q>=0?q:null;}
    if(action==='add'){
      var rows=Array.isArray(next.items)?next.items:[{id:next.id,quantity:next.quantity}];
      for(var i=0;i<rows.length;i++){
        var row=rows[i],q=quantity(row.quantity,1);if(!row.id||q===null||q<1)return invalid();
        var pid=resolveProductId(row.id,items);
        if(pid)simulated.push({product_id:pid,quantity:q});
      }
    } else if(action==='change'){
      var q=quantity(next.quantity,0);if(q===null)return invalid();
      var line=findLine(simulated,next.id)||(next.line!=null?simulated[Number(next.line)-1]:null);
      if(!line)return invalid();line.quantity=q;
    } else if(action==='update' && next.updates){
      var updates=next.updates;
      var tokens=Object.keys(updates);
      for(var j=0;j<tokens.length;j++){
        var token=tokens[j],q=quantity(updates[token],0);if(q===null)return invalid();
        var line=Array.isArray(updates)?simulated[Number(token)]:findLine(simulated,token);
        if(line)line.quantity=q;
        else {var pid=resolveProductId(token,items);if(pid)simulated.push({product_id:pid,quantity:q});}
      }
    }
    for(var k=0;k<limitKeys.length;k++){
      var pid=limitKeys[k],max=getMax(pid);
      if(max&&qtyInCartForProduct(pid,simulated)>max)return {blocked:true,message:config.components&&config.components[pid]?'Máximo de 1 unidade deste kit por carrinho.':config.components?'Limite de 3 unidades por sabor no 10.10, contando os kits e os produtos avulsos.':formatMessage(max)};
    }
    return {payload:next};
  }

  function blockedJsonResponse(message) {
    var body = JSON.stringify({
      status: 422,
      message: 'Erro de carrinho',
      description: message,
    });
    return new Response(body, {
      status: 422,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  // --- fetch ---
  var mutationQueue = Promise.resolve();
  window.fetch = function (input, init) {
    init = init || {};
    var url = typeof input === 'string' ? input : input && input.url;
    var action = isCartMutateUrl(url);
    if (!action) {
      return originalFetch(input, init);
    }

    var method = (init.method || (input && input.method) || 'GET').toUpperCase();
    if (method !== 'POST' && method !== 'PUT') {
      return originalFetch(input, init);
    }

    var body = init.body;
    var bodyReady = Promise.resolve(body);
    if (body == null && typeof Request !== 'undefined' && input instanceof Request) {
      bodyReady = input.clone().text();
    }

    var payload;

    var operation = mutationQueue.then(function(){return bodyReady.then(function(value){body=value;payload=parseBody(value);return refreshCartCache();});})
      .then(function (items) {
        var result = enforceLimits(action, payload, items);
        if (result.blocked) {
          notify(result.message);
          return blockedJsonResponse(result.message);
        }

        var nextInit = init;
        if (result.clamped && result.payload) {
          notify(result.message);
          nextInit = {};
          for (var key in init) {
            if (Object.prototype.hasOwnProperty.call(init, key)) {
              nextInit[key] = init[key];
            }
          }
          nextInit.body = rebuildBody(body, result.payload);
        }

        return originalFetch(input, nextInit).then(function (response) {
          return refreshCartCache().catch(function(){}).then(function(){return response;});
        });
      }).catch(function(){var message='Não conseguimos conferir o carrinho agora. Confira as quantidades antes de tentar novamente.';notify(message);return blockedJsonResponse(message);});
    mutationQueue = operation.catch(function(){});
    return operation;
  };

  // --- jQuery ---
  function patchJQuery($) {
    if(!$||!$.ajax||!$.Deferred||$.hsCartQtyLimitsPatched)return;
    $.hsCartQtyLimitsPatched=true;
    var ajax=$.ajax;
    $.ajax=function(url,options){
      var settings=typeof url==='string'?Object.assign({},options||{},{url:url}):Object.assign({},url||{});
      var action=isCartMutateUrl(settings.url),method=String(settings.type||settings.method||'GET').toUpperCase();
      if(!action||method!=='POST'&&method!=='PUT')return ajax.apply(this,arguments);
      var deferred=$.Deferred(),nativeRequest,aborted=false;
      var promise=deferred.promise({abort:function(){aborted=true;if(nativeRequest)nativeRequest.abort();return this;}});
      function reject(message){
        notify(message);var error={status:422,responseJSON:{status:422,description:message},responseText:JSON.stringify({status:422,description:message})};
        if(typeof settings.error==='function')settings.error.call(settings.context||settings,error,'error',message);
        if(typeof settings.complete==='function')settings.complete.call(settings.context||settings,error,'error');
        deferred.rejectWith(settings.context||settings,[error,'error',message]);
      }
      var operation=mutationQueue.then(function(){return refreshCartCache();}).then(function(items){
        if(aborted){deferred.rejectWith(settings,[{status:0},'abort','abort']);return;}
        var result=enforceLimits(action,parseBody(settings.data),items);
        if(result.blocked){reject(result.message);return;}
        return new Promise(function(resolve){
          nativeRequest=ajax.call($,settings);
          nativeRequest.done(function(){deferred.resolveWith(this,arguments);});
          nativeRequest.fail(function(){deferred.rejectWith(this,arguments);});
          nativeRequest.always(function(){refreshCartCache().catch(function(){}).then(resolve);});
        });
      }).catch(function(){reject('Não conseguimos conferir o carrinho agora. Tente novamente.');});
      mutationQueue=operation.catch(function(){});
      return promise;
    };
  }

  if (window.jQuery) {
    patchJQuery(window.jQuery);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      if (window.jQuery) patchJQuery(window.jQuery);
    });
  }

  document.addEventListener('cart-change', function () {
    refreshCartCache().catch(function(){});
  });

  ensureCart().catch(function(){});
})();
